import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 flex gap-8 tablet:gap-16"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "flex w-max cursor-pointer flex-col items-center justify-center gap-4" }
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = { class: "text-[0.688rem] capitalize leading-normal text-black-500 opacity-80" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($data.quickFilters.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedFilters, (filter) => {
          return (_openBlock(), _createElementBlock("div", {
            key: filter.label,
            title: filter.label,
            class: "flex items-center gap-x-8 max-tablet:w-44"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: 
            $data.imageFilterColor
              .replace(
                'black_small.jpg',
                `${filter.label
                  .toLowerCase()
                  .trim()
                  .normalize('NFD')
                  .replace(/^-+|-+$/g, '')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace('@', '')
                  .replace('/', '-')
                  .replace(/ /g, '-')}_150x.png`
              )
              .split('?')[0]
          ,
                class: _normalizeClass([[
            $data.activeFilters.includes(filter.value) && 'border-black border-[0.6px] border-opacity-25',
          ], "size-[2.125rem] cursor-pointer rounded-full shadow-custom-quick-menu-filter"]),
                onClick: $event => ($options.toggleFilter(filter.value, `${filter.param_name}=${filter.value}`))
              }, null, 10, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(filter.value), 1)
            ])
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}